export const SET_BEFORE_INSTALL_PROMPT_FIRE = 'SET_BEFORE_INSTALL_PROMPT_FIRE';
export const SET_LANDING_PAGE_CONTENT = 'SET_LANDING_PAGE_CONTENT';
export const SET_PARTNER_CONTENT = 'SET_PARTNER_CONTENT';
export const UNSET_PARTNER_CONTENT = 'UNSET_PARTNER_CONTENT';
export const SET_IS_EXTENSION_INSTALLED = 'SET_IS_EXTENSION_INSTALLED';